import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconLockOutlineSvg } from "./IconLockOutlineSvg.mjs";
const IconLockOutline = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconLockOutlineSvg, ...iconProps });
};
export {
  IconLockOutline
};
